import { z } from 'zod';

// 電話番号のバリデーションスキーマ（ForgotIDPageとForgotPasswordPageで共通使用）
export const phoneSchema = z.object({
  phone: z
    .string()
    .min(1, '電話番号は必須です')
    .regex(
      /^\+?\d{1,4}-?\d{1,4}-?\d{4}$/,
      '有効な携帯電話番号を入力してください（例: 09011112222）'
    )
    .transform((phone) => {
      phone = phone.replace(/[-\s]/g, '');
      // 電話番号を国際形式に変換（0から始まる場合は+81に変換）
      if (phone.startsWith('0')) {
        return `+81${phone.slice(1)}`;
      }
      return phone;
    }),
});

// // 電話番号のみのシンプルなスキーマ（フォーマット変換なし）
// export const phoneInputSchema = z.object({
//   phone: z
//     .string()
//     .min(1, '電話番号は必須です')
//     .regex(
//       /^0[789]0[0-9]{8}$/,
//       '有効な携帯電話番号を入力してください（例: 09011112222）'
//     ),
// });

// export const phoneSchema = z.object({
//     phone: z
//       .string()
//       .min(1, '電話番号は必須です')
//       .transform((phone) => phone.replace(/[-\s]/g, '')) // まずハイフン・空白除去
//       .refine((phone) => /^\+?\d{10,15}$/.test(phone), {
//         message: '有効な携帯電話番号を入力してください（例: 09011112222）',
//       }),
//   });
